import React, { useContext, useEffect, useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import SEO from "../components/seo";
import Layout from "../components/layout";
import useSiteMetadata from "../utils/useSiteMetadata"
import { removeSlashFromSlug } from '../utils/additionalFunctions';
import CustomMarkdown from "../utils/customMarkdown";
// import Signup from "../components/signup";
// import Hero from "../components/basic-components/hero";
// import Tiles from "../components/tiles";
// import CTAImg from "../assets/img/Help-you-scaled-e1588324743844.jpg";
// import LatestNewsCarousel from "../components/latest-news-carousel";
// import ImageCard from '../components/basic-components/image-card'

import '../scss/news-events.scss'
// import SubheadingText from "../components/basic-components/subheading-text";
import Img from "gatsby-image";
import GetImgUrl from "../utils/customFunctions";

import loadable from '@loadable/component'

const SubheadingText = loadable(() => import("../components/basic-components/subheading-text"))
const LatestNewsCarousel = loadable(() => import("../components/latest-news-carousel"))
const Tiles = loadable(() => import("../components/tiles"))
const Signup = loadable(() => import("../components/signup"))
const QuoteCarousel = loadable(() => import("../components/quote-carousel"))
const Branches = loadable(() => import("../components/branches-component"))
const Hero = loadable(() => import("../components/basic-components/hero"))
const Paragraph = loadable(() => import("../components/paragraph"))
const VideoComponent = loadable(() => import("../components/video-component"))
const StepsComponent = loadable(() => import("../components/steps-component"))
const FAQComponent = loadable(() => import("../components/faq-component"))
const SwirlComponent = loadable(() => import("../components/swirl-component"))


const IndexPage = () => {
  // const {getImgUrl} = useGlobalContext()
  // getImgUrl("asd")
  // console.log(GetImgUrl("a8026070-072a-586e-b423-2c9b261c378e"))

  

  const data = useStaticQuery(graphql`
   query MyQuery  {
      strapiNewsEvents {
        SEOTitle
        SEODescription
        Canonical
        MetaTags{
          MetaName
          MetaContent
        }
        PageComponents
        Header {
          Title
          Subtitle
          Visible
          LeftBgColor
          RightBgColor
          CTA
          URL
          CTASecondary
          URLSecondary
          Subheading
          SubheadingSummary
          Background {
            localFile {
              publicURL
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }

      allStrapiNewsArticle(sort: {order: DESC, fields: created_at}) {
        edges {
          node {
            Components
            Title
            slug
            Header {
              LeftBgColor
              RightBgColor
              Subtitle
              Background {
                localFile {
                  publicURL
                  childImageSharp {
                    fluid(quality: 90, maxWidth: 284,  maxHeight: 185,) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
      }

  
      allStrapiEvents( filter: {fields: {timestamp: {gt: 1634714790}}} sort: {order: ASC, fields: Date}) {
        edges {
          node {
            Date(formatString: "DD/MM/YYYY")
            Title
            slug
            Header {
              LeftBgColor
              RightBgColor
              Background {
                localFile {
                  absolutePath
                  publicURL
                  childImageSharp {
                    fluid(quality: 90, maxHeight: 185, maxWidth: 359) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);


  var headerData = data.strapiNewsEvents.Header != null ? {
    headerTitle: data.strapiNewsEvents.Header.Title,
    headerDescription: data.strapiNewsEvents.Header.Subtitle,
    headerCTAPrimaryLabel: data.strapiNewsEvents.Header.CTA||"",
    headerCTAPrimaryUrl: data.strapiNewsEvents.Header.URL||"",
    headerCTASecondaryLabel: data.strapiNewsEvents.Header.CTASecondary||"",
    headerCTASecondaryUrl: data.strapiNewsEvents.Header.URLSecondary||"",
    headerBgImage: data.strapiNewsEvents.Header.Background.localFile.childImageSharp.fluid,
    headerLeftBgColor: data.strapiNewsEvents.Header.LeftBgColor ? data.strapiNewsEvents.Header.LeftBgColor : '',
    headerRightBgColor: data.strapiNewsEvents.Header.RightBgColor ? data.strapiNewsEvents.Header.RightBgColor : '',
  } : {};

  const pageHasHeader = data.strapiNewsEvents.Header != null ? true : false; //check if Header is set
  var headerParagraphSet = false;
  //Filter events based on date

    let today = new Date();
    let day = today.getDate()
    let month = today.getMonth() + 1;
    let year = today.getFullYear();
    let fullDate = (year + '/' + month + '/' + day)

    
    let currentUnixDate = new Date(fullDate).getTime() / 1000;

    let filteredEventsByDate =  data.allStrapiEvents.edges.filter(e => {
     
      let eventDate = e.node.Date
      let reverseEventDate = eventDate.split('/').reverse().join('/')
      let unixDateEvent = new Date(reverseEventDate).getTime() / 1000;
      
      let events
      
     
      return   events =  unixDateEvent >= currentUnixDate
      
    })

    useEffect(() => {
      filteredEventsByDate.forEach(item => {
        item.node.slug = item.node.slug.toLowerCase()
       
      })
    }, [])

  /* <ImageCard
     img={GetImgUrl(item.ImageCarousel.Images.localFile___NODE).fluid}
     type={"normal"}
     title={item.Title}
     description={item.Text}
   />;*/

  /*
  data.strapiHomepage.HomepageSections {
    item.CTA !== undefined && item.CTA.length === 1 ? (
      <Tiles data={item.CTA} singleFlag={true}></Tiles>
    ) : (
      ""
    )
    // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
    //don't forget to fix this once the cta.length of a json (dynamic zone) is found
  } */
    const { siteUrl: url } = useSiteMetadata();

  return (
    <div>
      <Layout
        pageData={headerData}
        headerShow={data.strapiNewsEvents.Header != null ? data.strapiNewsEvents.Header.Visible : false}
        headerType="contact"
      >
        <SEO title={data.strapiNewsEvents.SEOTitle?data.strapiNewsEvents.SEOTitle:"News &amp; Events"} 
         description={data.strapiNewsEvents.SEODescription} 
         meta={data.strapiNewsEvents.MetaTags}
         canonical={data.strapiNewsEvents.Canonical ? data.strapiNewsEvents.Canonical : `${url + '/news-events/'}`}
         />

        {
          data.strapiNewsEvents.Header != null ?
          (data.strapiNewsEvents.Header.SubheadingSummary?
          <SubheadingText subheading={data.strapiNewsEvents.Header.Subheading} summary={data.strapiNewsEvents.Header.SubheadingSummary} endLine={false}/>
          :"") : ""
        }

        {/* <LatestNewsCarousel
          title={null}
          data={data.allStrapiNewsArticle}
          url={`/news`}
          component={'news'}
        ></LatestNewsCarousel> */}

        {/* [JRMEM-233] - commented because added switch case below */}
        {/* {data.strapiNewsEvents.PageComponents.map((item, index) => {

          return (
            <>
              {
                item.CTA !== undefined && item.CTA.length === 1 ? (
                  <Tiles key={index} data={item.CTA} singleFlag={true} type='normal' width='full' ></Tiles>
                ) : (
                   <Tiles key={index} data={item.CTA}></Tiles>
                )
                // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
                //don't forget to fix this once the cta.length of a json (dynamic zone) is found
              }
           
              {item.Testimonial 
                  ? (<div className="">
                      <QuoteCarousel quoteList={item.Testimonial}></QuoteCarousel>
                    </div>
                    ) 
                  : (
                    ""
                  )}
           
            </>
          );
        })}  */}
        {data.strapiNewsEvents.PageComponents.map((item, index) => {
            switch (item.strapi_component) {
              case "basic-components.paragraph":
                var forceH1Title = false;
                var overlaySwirl = false;
                if((pageHasHeader == false && headerParagraphSet == false) || item.IsHeader == true){
                  headerParagraphSet = true;
                  forceH1Title = true;
                }

                if(index == 0 && item.TopSwirl == true){ //if paragraph is the first item in pageComponents and has topSwirl then overlay the header image
                  overlaySwirl = true;
                }
                return (               
                    <Paragraph
                        key={index}
                        title={item.Title}
                        text={item.Text}
                        image={item.Image}
                        imagePosition={item.ImagePosition}
                        bgColor={item.BackgroundColor || ""}
                        topPadding={(item.TopPadding === true) ? true : false}
                        bottomPadding={(item.BottomPadding === true) ? true : false}
                        forceH1Title={forceH1Title}
                        alignment={item.ContentAlignment}
                        initialPadding={item.InitialPadding}
                        topSwirl={item.TopSwirl}
                        bottomSwirl={item.BottomSwirl}
                        bottomMargin={item.BottomMargin}
                        overlaySwirl={overlaySwirl}
                        hasLateralPadding={true}
                    ></Paragraph>
                )
              case "basic-components.hero-section":
                return(
                  <Hero
                    title={item.Hero.Title}
                    description={item.Hero.Description}
                    label={item.Hero.Label}
                    url={item.Hero.url}
                    key={index}
                    sectionStyle = "white"
                  ></Hero>
                )
              case "basic-components.branches-component":
                const branchesBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                return(
                  <Branches key={index} branchList={item.BranchesList} title={item.Title} sectionStyle={branchesBgColor} />
                )
              case "basic-components.video-section":
                return(
                  <VideoComponent key={index} src={item.YoutubeURL}/>
                )
              case "basic-components.testimonial-section":
                return(
                    <div key={index} className="">
                      <QuoteCarousel quoteList={item.Testimonial}></QuoteCarousel>
                    </div>
                )
              case "cta.cta-section":
                const sectionBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                const fullWidthSectionBgColo =  item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'white'; 
                return(
                  <div key={index}>
                    {item.CTA !== undefined && item.CTA.length > 1 ? (<Tiles data={item.CTA} width='half' key={index} sectionStyle={sectionBgColor}></Tiles>) : ("")}

                    {item.CTA !== undefined && item.CTA.length === 1 ? (<Tiles data={item.CTA} key={index} singleFlag={true} width='full' sectionStyle={fullWidthSectionBgColo}></Tiles>) : ("")
                      // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
                      //don't forget to fix this once the cta.length of a json (dynamic zone) is found
                    }
                  </div>
                )
              case "basic-components.text-section":
                return (               
                  item.Text ? (
                    <>
                      <CustomMarkdown key={index} children={item.Text} />
                          {item.Links 
                            ?<Link to={`${item.Links.URL}`}>
                                 {item.Links.Link}
                              </Link>  
                            : ''}
                    </>
                  ) : (
                    ""
                  )
                )
              case "basic-components.image-carousel":
                return (               
                  item.Images 
                    ? ( <div key={index} className="image_wrap">
                      <div className="image-section uk-cover-container uk-margin-none">
                        {/* <img src={item.Images.publicURL} alt="" data-uk-cover/> */}
                        <Img
                          // fluid={item.Images.childImageSharp.fluid}
                          fluid={GetImgUrl(item.Images.localFile___NODE).fluid}
                          alt={"image"}
                          data-uk-cover
                        ></Img>
                      </div>
                    </div>
                    ) 
                    : ("")
                )
              case "basic-components.image-carousel-section":
                return(
                    item.ImageCarousel ? (
                        <div key={index} className="image-section uk-height-medium uk-cover-container uk-margin-none">
                          <Img
                            fluid={
                              GetImgUrl(item.ImageCarousel.Images.localFile___NODE)
                                .fluid
                            }
                            alt="image"
                          ></Img>
                        </div>
                    ) : null
                )
              case "basic-components.steps-component":
                return(
                  <StepsComponent key={index} stepsList={item.StepsList} sectionStyle="white" />
                )
              case "basic-components.faq-component":
                return(
                  <FAQComponent key={index} faqList={item.FAQList} sectionStyle="white" />
                )             
              case "basic-components.signup-component":
                return(
                  <Signup
                    title="Sign Up to Our Newsletter"
                    description="Get updates on all the lastest information, or stay informed about our courses"
                    buttonLabel="Sign Up"
                    sectionStyle = "white"
                  />
                )
              case "basic-components.swirl-component":                
                return(
                  <SwirlComponent 
                    key={index} 
                    bgColor={item.SwirlColor} topSwirl={item.Position == "Top" ? true : false} 
                    />
                )
              case "basic-components.news-articles-component":                
                return(
                  <LatestNewsCarousel
                      title={null}
                      data={data.allStrapiNewsArticle}
                      url={`/news`}
                      component={'news'}
                    ></LatestNewsCarousel>
                )
              default:
                return ('')
          }
        }
        )} 

        {/*TOASK:what is the below code doing? how to test - it is not displayed*/}
        {/*  title={data.strapiNewsEvents ? data.strapiNewsEvents.Header.Title: 'Upcoming Events at Mindful Memorials'} title for event tiles  section*/}
        {
          filteredEventsByDate.length >= 1 ? (
            <div className='divider-wrapper'>
              <div className="padding-bottom">
                <Tiles title={'Upcoming Events at Mindful Memorials'} data={filteredEventsByDate} url={'/events'} singleFlag={true} type='horizontal' width='half' ></Tiles>
              </div>
            </div>
          ) : ''
        }
        
        {/* {data.strapiNewsEvents.HomepageSections.map((item, index) => {


        return(
          <>
            {(item.CTA !== undefined && item.CTA.length > 1 )?<Tiles data={item.CTA}></Tiles>:""}
            
            {
            (item.CTA !== undefined && item.CTA.length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
            // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
            //don't forget to fix this once the cta.length of a json (dynamic zone) is found
            }

            {(item.Hero)?<Hero 
            title={item.Hero.Title}
            description={item.Hero.Description}
            label={item.Hero.Label}
            url={item.Hero.url}
            ></Hero>:""}
          </>
        )
      })} */}

        {/* old hero kept for posterity. will be removed */}
        {/* <Hero 
        title={"Welcome to Mindful Memorials"}
        description={"Aute reprehenderit aliquip exercitation tempor enim aliqua dolore. Tempor nulla quis sunt laborum mollit ut sint do elit cillum. Eiusmod sint culpa labore minim nulla exercitation et aute excepteur ipsum qui aute exercitation quis."}
        label={"Find our more"}
        url={"/collections"}
        ></Hero> */}
        
        {/* <Signup
          title="Sign Up to Our Newsletter"
          description="Get updates on all the lastest information, or stay informed about our courses"
          buttonLabel="Sign Up"
        /> */}
      </Layout>
    </div>
  );
};

export default IndexPage;
